import React from 'react';
import SvgIcon from './SvgIcon';

const Megaphone = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            d="M7.5 14.25c0 2.25 0 5.25 3.75 6.75M7.5 6.75v7.5M21 12.75a2.249 2.249 0 100-4.5"
            stroke="currentColor"
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M8.25 14.25H3A2.25 2.25 0 01.75 12V9A2.25 2.25 0 013 6.75h6.75A20.625 20.625 0 0021 3v15a18.9 18.9 0 00-11.25-3.75h-1.5z"
            stroke="currentColor"
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);

Megaphone.displayName = 'MegaphoneIcon';

export default Megaphone;
